
const videoTypes = {
	intro: 'Intro',
	Class: 'Class'
}

// =================== //
//		  HERO
// =================== //

// Currently Gavin Strange
export async function heroData() {
	const linkToMasterPage = '/gavin-strange';
	const artistName = 'Gavin Strange';
	return {
		video_1: {
			id: '1',
			container: '#box176',
			button: '#heroVideoPlay',
			image: '#heroVideoThumbnail',
			video: 'https://video.wixstatic.com/video/0d6674_d235ab5e2e4d42c09d6e43d4dd5aa62c/1080p/mp4/file.mp4',
			altText: 'Video of designer Gavin Strange introducing himself and his series of video tutorials about how to use design features like header scrolls, VideoBox and hover interactions on Editor X.',
			title: 'Meet Gavin.',
			description: 'Director and designer Gavin Strange always shines a spotlight on the inner creative voice that fuels his unparalleled works of art. Watch him bring his passion and energy to the Editor X canvas with features like header scrolls, VideoBox and hover interactions. ',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
	
		video_2: {
			id: '2',
			button: '#heroPlaylist1',
			video: 'https://video.wixstatic.com/video/0d6674_84390e780e48491c90e064799881ba0a/1080p/mp4/file.mp4',
			altText: 'Video tutorial by designer Gavin Strange showing how he uses header scroll effects to design the introduction to his website on Editor X. ',
			title: 'Draw the curtains.',
			description: 'Learn how to get creative with header scrolls to give the top section of your site a whole new functionality. See how Gavin sets up an impressive introduction to the rest of his site.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			button: '#heroPlaylist2',
			video: 'https://video.wixstatic.com/video/0d6674_407141ee8fe647cf9e85ec5615ca630e/1080p/mp4/file.mp4',
			altText: 'Video tutorial by designer Gavin Strange showing how he designs his video player directly on the Editor X canvas using features like VideoBox and lightbox.',
			title: 'The reel deal.',
			description: 'Discover how to design your video player directly on the canvas. Gavin takes you through his VideoBox creation process step by step, using features like lightbox and hover interactions to seal the deal—piñata included.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_4: {
			id: '4',
			button: '#heroPlaylist3',
			video: 'https://video.wixstatic.com/video/0d6674_1f408145a70343398e6a9c1b5b04f57e/1080p/mp4/file.mp4',
			altText: 'Video tutorial by designer Gavin Strange showing how he applies hover interactions to his site project gallery on Editor X.',
			title: 'Hover lover.',
			description: 'Don’t hesitate to keep the dialogue fun and interesting between the viewer and site page. Check out how Gavin uses CSS grid and hover interactions to create a dynamic project gallery, fit for every screen.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}


// =============================== //
//		  VIDOES SECTION 01
// =============================== //
// Daniel Aristizábal
export async function danielSectionData() {
	const linkToMasterPage = '/daniel-aristizabal';
	const artistName = 'Daniel Aristizabal';
	return {
		video_1: {
			id: '1',
			container: '#section3Box1',
			button: '#section3button1',
			video: 'https://video.wixstatic.com/video/311dce_ec7fd2f29f5249ad80ad55dea47b2bed/1080p/mp4/file.mp4',
			altText: 'Video of artist Daniel Aristizábal introducing himself and his series of video tutorials about how to use design features like text scale, custom menus and sticky position on Editor X. ',
			title: 'Meet Dani.',
			description: 'This art director, artist and digital illustrator will not hesitate to shock you with bold designs and daring art pieces. Dani enjoys using modern technology to bring his surreal visions to life. This time, he’s using Editor X to show you how features like text scale, custom menus and sticky position can transform your designs into masterpieces.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
		video_2: {
			id: '2',
			container: '#section3Box2',
			button: '#section3button2',
			video: 'https://video.wixstatic.com/video/311dce_b7274ffae7074b3e857fa6d0ab9c36bd/1080p/mp4/file.mp4',
			altText: 'Video for design class with Daniel Aristizábal. In this video, he uses text scale to deliver a powerful message on every screen size.',
			title: 'Text me.',
			description: 'Take a look at how to use text scale to make sure your audience gets the same viewing experience on any device. See how Dani adds his own personal touch to his site bio.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			container: '#section3Box3',
			button: '#section3button3',
			video: 'https://video.wixstatic.com/video/311dce_606d6bae6aa44eb1a1f0eb2b7468fa30/1080p/mp4/file.mp4',
			altText: 'Video for design class with Daniel Aristizábal. In this video, he creates something cool using custom menus.',
			title: 'Normal is boring.',
			description: 'Check out how Dani takes something as ordinary as a navigation menu, and turns it into something totally unique with his own custom designs.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_4: {
			id: '4',
			container: '#section3Box4',
			button: '#section3button4',
			video: 'https://video.wixstatic.com/video/311dce_2264d434042b47569d75ce7700aa1422/1080p/mp4/file.mp4',
			altText: 'Video for design class with Daniel Aristizábal. In this video, he uses sticky position to make his design interactive.',
			title: 'Sticky eggs.',
			description: 'Make your next design an interactive experience using sticky position. Discover how Dani uses the feature to create a cool scroll effect that makes his art move along the page.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}


// =============================== //
//		  VIDOES SECTION 02
// =============================== //
// AMBER VITTORIA
export async function amberSectionData() {
	const linkToMasterPage = '/amber-vittoria';
	const artistName = 'Amber Vittoria';
	return {
		video_1: {
			id: '1',
			container: '#section1Box1',
			button: '#section1button1',
			video: 'https://video.wixstatic.com/video/311dce_b1405c7f6c4147dbbb5e076f9c1a7b3a/1080p/mp4/file.mp4',
			altText: 'Video about artist Amber Vittoria. In the video she  presents a tutorial and talks through her process of incorporating her art into a webpage design.',
			title: 'Meet Amber Vittoria.',
			description: 'Amber Vittoria is an artist and illustrator based in NYC. She focuses on empowering women and showcasing the female form, presenting alternatives to the ‘ideal female physique’ that’s usually seen in the media.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
		video_2: {
			id: '2',
			container: '#section1Box2',
			button: '#section1button2',
			video: 'https://video.wixstatic.com/video/12d367_4d6780d0cb524fee9a108f46ad32697c/1080p/mp4/file.mp4',
			altText: 'Video for design class with Amber Vittoria. In this video, she uses a slider to display art in a cool way.',
			title: 'The slider.',
			description: 'Get to know a fun way of using a slider in your design. Join Amber as she shows you how to combine it with text and images for an interesting effect.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			container: '#section1Box3',
			button: '#section1button3',
			video: 'https://video.wixstatic.com/video/12d367_d845073a8cff4ee984376c72121704a0/1080p/mp4/file.mp4',
			altText: 'Video for design class with Amber Vittoria. In this video, she creates a cool way of displaying a portfolio using sticky position.',
			title: 'Cover flow.',
			description: 'Discover a creative way to display an online portfolio using sticky position. See how Amber’s colorful design incorporates her art in a way that’s both striking and engaging.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_4: {
			id: '4',
			container: '#section1Box4',
			button: '#section1button4',
			video: 'https://video.wixstatic.com/video/12d367_89750bcd2178438d863e1d67ca788349/1080p/mp4/file.mp4',
			altText: 'Video for design class with Amber Vittoria, In this video, she shows how to control element placement with sticky position and custom grid.',
			title: 'Day and night.',
			description: 'Explore interesting visual displays created using custom grid and sticky position. Follow Amber as she takes you through the steps to build her colorful and creative design.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}


// =============================== //
//		  VIDOES SECTION 03
// =============================== //
// Zipeng Zhu
export async function zipengSectionData() {
	const linkToMasterPage = '/zipeng-zhu';
	const artistName = 'Zipeng Zhu';
	return {
		video_1: {
			id: '1',
			container: '#section2Box1',
			button: '#section2button1',
			video: 'https://video.wixstatic.com/video/311dce_bfed6c36a6ed4f4990ee5248c7c9d651/1080p/mp4/file.mp4',
			altText: 'Video that introduces Zipeng and his artwork with a sneak preview into his upcoming videos on Editor X where he will work with features like sticky position and overflow.',
			title: 'Meet Zipeng Zhu.',
			description: 'As an art director, designer, animator and illustrator, Zipeng is obsessed with razzle-dazzle poppy, vibrant creations. Zipeng has chosen 3 super cool design features to explore: overflow, sticky position and responsive behavior. He’s prepared Classes showing off his own style with a few little hacks to show you how to incorporate these features on the platform.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
		video_2: {
			id: '2',
			container: '#section2Box2',
			button: '#section2button2',
			video: 'https://video.wixstatic.com/video/311dce_9eab1f4b87c1411eaf5d9e2f1aa823a3/1080p/mp4/file.mp4',
			altText: 'Video for design class with Zipeng Zhu. In the video, he shows how to creative an interactive effect using overflow.',
			title: 'Looking for love.',
			description: 'Discover a great way to engage site visitors using overflow. Zipeng’s mesmerizing eyeball design is interactive and fun. Dive into his colorful world and see how he creates this great effect.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			container: '#section2Box3',
			button: '#section2button3',
			video: 'https://video.wixstatic.com/video/311dce_41623f1a9e474284a17a760fcf429048/1080p/mp4/file.mp4',
			altText: 'Video for design class with Zipeng Zhu. In the video, he uses sticky position to create an impressive scroll effect.',
			title: 'Burger deluxe.',
			description: 'Watch Zipeng’s latest mouthwatering design unfold. Find out how to use sticky position and careful margin calculations to create this gorgeous scroll and stack effect.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_4: {
			id: '4',
			container: '#section2Box4',
			button: '#section2button4',
			video: 'https://video.wixstatic.com/video/311dce_277a467336b8404f94bf15deed0c5925/1080p/mp4/file.mp4',
			altText: 'Video for design class with Zipeng Zhu. In the video, he plays with the responsive capabilities of Editor X. ',
			title: 'Bring \'em together.',
			description: 'See how Zipeng plays with the responsive capabilities of Editor X. He controls what you see at each viewport width to create this quirky graphic delight.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}


// =============================== //
//		  VIDOES SECTION 04
// =============================== //
// David Milan
export async function davidSectionData() {
	const linkToMasterPage = '/david-milan';
	const artistName = 'David Milan';
	return {
		video_1: {
			id: '1',
			container: '#section4Box1',
			button: '#section4button1',
			video: 'https://video.wixstatic.com/video/0d6674_44c45a3e2ed147c3bd69e1bc7d1eff03/1080p/mp4/file.mp4',
			altText: 'Video of man speaking to the camera with a plant and lamp in the background. There is grey and black shading behind his right side.',
			title: 'Meet David Milan.',
			description: 'Lettering artist David Milan loves combining vibrant typography with thought-provoking quotes and pop culture icons—and the result is always eye-catching. David brings his laid back flair to his tutorials where he uses animation, sticky position and scroll effects to create an inviting site loading experience, an online gallery and more.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
		video_2: {
			id: '2',
			container: '#section4Box2',
			button: '#section4button2',
			video: 'https://video.wixstatic.com/video/0d6674_0293c721e05f4cccb09abc1fe25280f6/1080p/mp4/file.mp4',
			altText: 'Video showing a scroll effect on a website. There are words and a picture on the screen in layers and as you scroll down the layers pile up together.',
			title: 'Mix & match.',
			description: 'Discover how to incorporate sticky position and margins to create a cool gallery.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			container: '#section4Box3',
			button: '#section4button3',
			video: 'https://video.wixstatic.com/video/0d6674_0e648ba8b2ba4fe684d750dc91d88ff7/1080p/mp4/file.mp4',
			altText: 'Video showing a scroll effect using the same lettering in different colors. As you scroll down the page, the lettering changes colors.',
			title: 'Layer it up.',
			description: 'Watch David combine scroll effects and layering to produce unexpected results.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_4: {
			id: '4',
			container: '#section4Box4',
			button: '#section4button4',
			video: 'https://video.wixstatic.com/video/0d6674_327827eb2d8342058b122e1bed7d0d33/1080p/mp4/file.mp4',
			altText: 'Video showing a site loading experience using animation. As you enter the site, the main image loads and then the signature of the artist loads as well.',
			title: 'Loading...',
			description: 'Learn how to build a funky site loading experience using animation.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}
// =============================== //
//		  VIDOES SECTION 05
// =============================== //
// Leta Sobierajski
export async function letaSectionData() {
	const linkToMasterPage = '/leta-sobierajski';
	const artistName = 'Leta Sobierajski';
	return {
		video_1: {
			id: '1',
			container: '#section5Box1',
			button: '#section5button1',
			video: 'https://video.wixstatic.com/video/0d6674_95556e12d4dd4843bace39e64b515fc1/1080p/mp4/file.mp4',
			altText: 'Video of designer Leta Sobierajski introducing herself and her series of video tutorials about how to use design features like header scrolls and sticky position on Editor X.',
			title: 'Meet Leta Sobierajski.',
			description: 'Co-founder of Brooklyn based studio, Wade and Leta, Leta Sobierajski challenges the conventional to create captivating visuals across many mediums. Combining graphic design elements with photography and art direction, Leta is able to transform tangible objects into intangible emotional experiences. Learn how she explores features like sticky position and header scrolls on Editor X.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
		video_2: {
			id: '2',
			container: '#section5Box2',
			button: '#section5button2',
			video: 'https://video.wixstatic.com/video/0d6674_4c77b81c2bc74b6caf90dcbcbd1797c7/1080p/mp4/file.mp4',
			altText: 'Video tutorial by designer Leta Sobierajski showing how she uses CSS grid and sticky position to make spheres appear on the page as you scroll. ',
			title: 'Spheres in motion.',
			description: 'Learn how to use features like CSS grid and sticky position to create a dynamic visual experience. See how Leta makes these spheres appear as she scrolls the page. That’s her actual arm—by the way.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			container: '#section5Box3',
			button: '#section5button3',
			video: 'https://video.wixstatic.com/video/0d6674_0d0e997f3c5a46d6a6e83de1025a80a4/1080p/mp4/file.mp4',
			altText: 'Video tutorial by designer Leta Sobierajski showing how she uses scroll animation to turn her site header into a footer as you scroll.',
			title: 'Head to toe.',
			description: 'The real secret to creating a powerful visual impact is all in the details. Discover how Leta uses scroll animation to turn her header into a footer as well.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}

// =============================== //
//		  VIDOES SECTION 06
// =============================== //
// Gavin Strange
export async function gavinSectionData() {
	const linkToMasterPage = '/gavin-strange';
	const artistName = 'Gavin Strange';
	return {
		video_1: {
			id: '1',
			container: '#section6Box1',
			button: '#section6button1',
			video: 'https://video.wixstatic.com/video/0d6674_d235ab5e2e4d42c09d6e43d4dd5aa62c/1080p/mp4/file.mp4',
			altText: 'Video of man speaking to the camera with a plant and lamp in the background. There is grey and black shading behind his right side.',
			title: 'Meet Gavin.',
			description: 'Director and designer Gavin Strange always shines a spotlight on the inner creative voice that fuels his unparalleled works of art. Watch him bring his passion and energy to the Editor X canvas with features like header scrolls, VideoBox and hover interactions. ',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.intro
		},
		video_2: {
			id: '2',
			container: '#section6Box2',
			button: '#section6button2',
			video: 'https://video.wixstatic.com/video/0d6674_84390e780e48491c90e064799881ba0a/1080p/mp4/file.mp4',
			altText: 'Video showing a scroll effect on a website. There are words and a picture on the screen in layers and as you scroll down the layers pile up together.',
			title: 'Draw the curtains.',
			description: 'Learn how to get creative with header scrolls to give the top section of your site a whole new functionality. See how Gavin sets up an impressive introduction to the rest of his site.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_3: {
			id: '3',
			container: '#section6Box3',
			button: '#section6button3',
			video: 'https://video.wixstatic.com/video/0d6674_407141ee8fe647cf9e85ec5615ca630e/1080p/mp4/file.mp4',
			altText: 'Video showing a scroll effect using the same lettering in different colors. As you scroll down the page, the lettering changes colors.',
			title: 'The reel deal.',
			description: 'Discover how to design your video player directly on the canvas. Gavin takes you through his VideoBox creation process step by step, using features like lightbox and hover interactions to seal the deal—piñata included.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		},
		video_4: {
			id: '4',
			container: '#section6Box4',
			button: '#section6button4',
			video: 'https://video.wixstatic.com/video/0d6674_1f408145a70343398e6a9c1b5b04f57e/1080p/mp4/file.mp4',
			altText: 'Video showing a site loading experience using animation. As you enter the site, the main image loads and then the signature of the artist loads as well.',
			title: 'Hover lover',
			description: 'Don’t hesitate to keep the dialogue fun and interesting between the viewer and site page. Check out how Gavin uses CSS grid and hover interactions to create a dynamic project gallery, fit for every screen.',
			masterPage: linkToMasterPage,
			artist: artistName,
			videoType: videoTypes.Class
		}
	}
}